import { t } from '@lingui/core/macro';
import { NoddiBasicCard, NoddiIconButton } from 'noddi-ui-web';
import { useBookingAddress } from 'noddi-web';
import { useAnnouncementActions, useIsAnnouncementHidden } from './publicAnnouncementStore';

export const PublicAnnouncement = () => {
  const bookingAddress = useBookingAddress();

  const addressId = bookingAddress?.id;

  const { hideAnnouncement } = useAnnouncementActions();

  const isAnnouncementHidden = useIsAnnouncementHidden(addressId);

  if (isAnnouncementHidden || !bookingAddress?.publicAnnouncement || !addressId) {
    return null;
  }

  return <Announcement announcement={bookingAddress.publicAnnouncement} onClick={() => hideAnnouncement(addressId)} />;
};

const Announcement = ({ announcement, onClick }: { announcement: string; onClick: () => void }) => (
  <div role='region' aria-label={t`Announcement`}>
    <NoddiBasicCard className='bg-warning50'>
      <div className='flex justify-between gap-4'>
        <span>{announcement}</span>
        <NoddiIconButton
          iconName='X'
          className='-mt-2'
          variant='ghost'
          onClick={onClick}
          aria-label={t`Dismiss announcement`}
        />
      </div>
    </NoddiBasicCard>
  </div>
);
